<template>
    <v-row class="ma-n4">
        <template v-for="(item, index) in items">
            <v-col cols="auto" class="pa-4" :key="index">
                <v-tooltip :disabled="!item.tooltip" bottom>
                    <template #activator="{ attrs, on }">
                        <v-chip v-bind="{ ...attrs, ...item }" v-on="on"> {{ item.text }} </v-chip>
                    </template>
                    <template v-if="!!item.tooltip">
                        <div class="item-badge__tooltip">
                            {{ item.tooltip }}
                        </div>
                    </template>
                </v-tooltip>
            </v-col>
        </template>
    </v-row>
</template>

<script>
import { initLecture } from "@/store/lecture";

export default {
    props: {
        value: { type: Object, default: initLecture },
    },
    computed: {
        items() {
            let items = [];
            if (this.value.isPublic) {
                items.push({
                    text: "공개",
                    dark: true,
                    color: "blue",
                    small: true,
                });
            } else {
                items.push({
                    text: "비공개",
                    dark: true,
                    color: "grey",
                    small: true,
                });
            }

            if (this.value.isActive) {
                items.push({
                    text: "접근가능",
                    dark: true,
                    color: "green",
                    small: true,
                });
            } else {
                items.push({
                    text: "접근불가",
                    dark: true,
                    color: "orange",
                    small: true,
                });
            }

            if (this.value.isStream) {
                items.push({
                    text: "실시간",
                    color: "white",
                    small: true,
                    class: "item-badge--is-stream",
                });
            }

            if (this.value.isCensored) {
                items.push({
                    text: "검열처리",
                    dark: true,
                    color: "red",
                    small: true,
                    tooltip: "관리자에 의해 검열처리된 영상입니다.\r\n자세한 내용은 1:1문의로 확인하실 수 있습니다.",
                });
            }

            return items;
        },
    },
};
</script>

<style lang="scss" scoped>
.item-badge {
    &--is-stream {
        border: 1px solid red !important;
        color: red;
    }

    &__tooltip {
        text-align: center;
        white-space: pre-line;
    }
}
</style>